import { Helmet } from 'react-helmet-async';

function PageHead(props: {
  title: string;
  description: string;
}) {
  return (
    <Helmet>
      <title>{props.title}</title>

      <meta name="title" content={props.title} />
      <meta name="description" content={props.description} />

      <meta property="og:type" content="website"/>
      <meta property="og:title" content={props.title} />
      <meta property="og:description" content={props.description} />

      <meta property="twitter:card" content="summary_large_image"/>
      <meta property="twitter:title" content={props.title} />
      <meta property="twitter:description" content={props.description} />

    </Helmet>
  )
}

export default PageHead
